var querySelectorWrapper = function (selector) {
    return document.querySelector(selector);
};
var windowLocationAssignWrapper = function (url, isNewTab) {
    if (isNewTab) {
        window.open(url, '_blank');
    }
    else {
        window.location.assign(url);
    }
};
export { querySelectorWrapper, windowLocationAssignWrapper };
